import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { computed, observable } from 'mobx-angular';
import {
  ITaskSupplierScheduleStoreTask,
  TaskSupplierScheduleSource,
  TaskSupplierScheduleStepStore,
  TaskSupplierScheduleStore,
} from './task-supplier-schedule-store';
import { TaskCollectionTravelMode } from '../../enums/task-collection-travel-mode.enum';

@Component({
  selector: 'task-supplier-schedule-panel',
  templateUrl: './task-supplier-schedule-panel.component.html',
  styleUrls: ['./task-supplier-schedule-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskSupplierSchedulePanelComponent implements OnInit {
  @Input() @observable public supplierScheduleStore: TaskSupplierScheduleStore;

  @Input() public mobileView: boolean = false;

  @computed public get taskSupplierScheduleStore(): TaskSupplierScheduleStepStore {
    return this.isDropOff ? this.supplierScheduleStore.dropOff : this.supplierScheduleStore.pickUp;
  }

  @Input() public task: ITaskSupplierScheduleStoreTask = null;

  @Input() public price: number | null = null;

  @Input() isDropOff: Boolean = false;

  @Input() @observable public source: TaskSupplierScheduleSource =
    TaskSupplierScheduleSource.JobDeployment;

  @Output() taskSupplierScheduleStoreChange: EventEmitter<TaskSupplierScheduleStepStore> =
    new EventEmitter<TaskSupplierScheduleStepStore>();

  constructor() {}

  ngOnInit(): void {}

  transportModes = [
    { value: TaskCollectionTravelMode.Driving, icon: 'la-car' },
    { value: TaskCollectionTravelMode.PublicTransport, icon: 'la-bus' },
    { value: TaskCollectionTravelMode.Walking, icon: 'la-walking' },
    { value: TaskCollectionTravelMode.Cycling, icon: 'la-biking' },
  ];

  @computed public get title() {
    return this.taskSupplierScheduleStore.isDropOff ? 'Drop Off' : 'Pick Up';
  }

  setTransportMode(value: number) {
    this.supplierScheduleStore.pickUp.travelMode =
      value == this.supplierScheduleStore.pickUp.travelMode ? null : value;
  }
}
